export const queryKeys = {
  REGION_CITIES_VIEW: "REGION-CITIES_VIEW",
  ADDRESS_REGION: "ADDRESS_REGION",
  ADDRESS_DISTRICT: "ADDRESS_DISTRICT",
}
